import { Inbox } from 'lucide-react'
import { type ReactNode } from 'react'

export function EmptyState({
  icon = <Inbox className="h-8 w-8 text-accent" />,
  title,
  message,
  action,
}: {
  icon?: ReactNode
  title: string
  message?: string | null
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-10 text-center">
      <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-accent-soft ring-1 ring-accent/10">{icon}</div>
      <div className="font-semibold text-heading">{title}</div>
      {message ? <div className="mt-1 max-w-md text-sm text-muted">{message}</div> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
